import React from "react"
import PageTransition from 'gatsby-plugin-page-transitions'

import get from 'lodash/get'
import startCase from 'lodash/startCase'
import map from 'lodash/map'
import filter from 'lodash/filter'
import find from 'lodash/find'

import Header from '../components/Header/index'
import {Helmet} from 'react-helmet'

import BlogMenu from '../components/BlogMenu'
import BlogPostExcerpt from '../components/BlogPostExcerpt'



export default ({ data }) => (<PageTransition>
  <div className="Atrakeur-Page">
    <Helmet>
      <meta charSet="utf-8" />
      <title>Atrakeur Blog | {startCase(get(data, 'contentfulTag.name'))}</title>
    </Helmet>

    <Header
      contentText={`<h1>${startCase(get(data, 'contentfulTag.name'))}</h1>`}
      contentImage={get(data, 'contentfulTag.featuredImage.resolutions')}
      size="medium" />

    <div className="Atrakeur-Content">
      { map(
        filter(data.allContentfulBlogPost.edges, node => find(node.node.tags, {id:  data.contentfulTag.id})),
        ({node: post}, index) => (
          <BlogPostExcerpt post={post} inverted={index % 2 == 1} key={post.id} />
        )
      )}

    </div>
  </div>
</PageTransition>)

export const query = graphql`
query TagsQuery($id: String!) {
	contentfulTag(id: { eq: $id }) {
		id
    name
    slug
    featuredImage {
			resolutions(width: 2048) {
        ...GatsbyContentfulResolutions
      }
    }
	}

  allContentfulBlogPost(sort: { fields: [createdAt], order: DESC}) {
    edges {
      node {
        id
        title
        slug
        category {
          id
          slug
        }
        tags {
          id
          name
          slug
        }
        featured {
          id
          resolutions(width: 2048) {
            ...GatsbyContentfulResolutions
          }
        }
        childContentfulBlogPostContentTextNode {
          childMarkdownRemark {
            excerpt(pruneLength: 300)
          }
        }
      }
    }
	}
}
`



// WEBPACK FOOTER //
// ./src/templates/Tag.js